<template>
    <div class="main-body">
        <h2>Campaign Report</h2>
        <div class="action-bar">
            <el-form :inline="true">
                <el-form-item>
                    <el-button size="small" icon="el-icon-refresh" @click="fetchData"></el-button>
                </el-form-item>
            </el-form>
        </div>
        <div>
            <el-table :data="tableData" v-loading="tableLoading" border>
                <el-table-column prop="campaign_id" :label="$strings('word/campaign_id')"></el-table-column>
                <el-table-column prop="campaign_name" :label="$strings('word/campaign_name')"></el-table-column>
                <el-table-column prop="is_flash" :label="$strings('word/is_flash')"></el-table-column>
                <el-table-column prop="is_unicode" :label="$strings('word/is_unicode')"></el-table-column>
                <el-table-column prop="schedule_time" :label="$strings('word/schedule_time')"></el-table-column>
                <el-table-column prop="ct_time" :label="$strings('word/ct_time')">
                    <template slot-scope="scope">
                        {{ convertUnixToDate(scope.row.ct_time) }}
                    </template>
                </el-table-column>
                <el-table-column :label="$strings('word/operation')">
                    <template slot-scope="scope">
                        <el-link type="primary" @click="onReport(scope.row)">{{ $strings('word/report') }} >></el-link>
                    </template>
                </el-table-column>
            </el-table>
        </div>
    </div>
</template>

<script>
import {CpSiteCampaignReportRead} from "../../../../api/cpsite/api";
import {GetItem} from "../../../../utils/storage";
import {UnixToDateYMD} from "../../../../utils/time";
import {STORAGE_KEY_LOGIN_TZ} from "../../../../config/config";

export default {
    name: "cpsite-send-report",
    data() {
        return {
            tableLoading: true,
            tableData: [],
            filter: {page: 1, size: 10, group_id: ''},
        }
    },
    created() {
        this.fetchData();
    },
    methods: {
        onReport(row) {
            this.$router.push('/cpsite/send-report-detail/' + row.campaign_id + '/' + row.campaign_name);
        },
        convertUnixToDate(ts) {
            let tz = parseInt(GetItem(STORAGE_KEY_LOGIN_TZ))
            return UnixToDateYMD(ts, tz);
        },
        fetchData() {
            this.tableLoading = true;
            CpSiteCampaignReportRead(this.filter).then((resp) => {
                if (resp.data.data.count > 0) {
                    this.tableData = resp.data.data.rows;
                }
            }).finally(() => {
                this.tableLoading = false;
            });
        }
    }
}
</script>

<style scoped lang="scss">
.action-bar {
    display: flex;
    flex-direction: column;
    justify-items: flex-end;
    align-items: flex-end;
}
</style>